import React, { useEffect } from "react";
import { Box, Button, IconButton, Stack, Typography, styled } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ChatWindow from "components/chat/ChatDetailWindow";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useForm } from "react-hook-form";
import ChatSubmissionForm from "components/chat/ChatSubmissionForm";
import { urlSupportPage } from "services/utils/globalVariables";
import { ChatTitleText } from "components/typography/text";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getCookie } from "services/utils/CookieHandler";
import { useState } from "react";
import { useContextState } from "services/context/MainContext";
import { ChatDetailLoader, ChatSubmitLoader } from "components/loaders/ChatLoaders";

const BackButtonTopStyle = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        padding: 16px 19px;
        background: #16423C;
        justify-content: space-between;
        border-radius: 0 0 8px 8px;
        z-index: 999;
    `
)

const ChatBottomStyle = styled(Stack)(
    ({ theme }) => `
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        padding: 16px 19px;
        background: #16423C;
        border-radius: 8px 8px 0 0;
        z-index: 999;
    `
)

export default function ChatDetailPage({ connection }) {

    const [data, setData] = useState([])
    const [loader, setloader] = useState(false)

    const { ticketList } = useContextState()

    const routerParams = useParams()
    const navigate = useNavigate()

    //Subject for top title
    //loginInfo is logged user data
    const loginInfo = getCookie("loginData")
    const ticketSubject = ticketList ? ticketList?.filter((val) => val.Id == routerParams.chatId)[0]?.Subject : "---"

    //Handling connection when on detail
    useEffect(() => {
        if(connection?._connectionState === "Connected") {
            connection.send("GetTicketMessages", +(routerParams.chatId), loginInfo.accessToken)
            connection.on("MessagesChat", (res) => {
                setData(res.data)
                let list = []
                res.data.map(function (item) {
                    if (item.CreatedUserId != loginInfo.userId && !item.IsSeen && +(routerParams.chatId) == res.data[0].TicketId) {
                        list.push(item.Id)
                    }
                })

                if (list.length) {
                    connection.send("SeenMessage", list, +(routerParams.chatId), loginInfo.userId, loginInfo.accessToken)
                }
            })
        }
    }, [connection])

    return (
        <Stack sx={{direction: "ltr !important", minHeight: "calc(100vh - 160px)"}}>
            <BackButtonTopStyle direction="row">
                <Stack direction="row" spacing={2} sx={{width: "calc(100% - 40px)"}}>
                    {
                        ticketSubject?.length > 60 &&
                        <InfoOutlinedIcon sx={{color: "white", fontSize: "20px"}} />
                    }
                    <ChatTitleText noWrap>{ticketSubject}</ChatTitleText>
                </Stack>
                <ArrowBackIosNewIcon sx={{color: "white", fontSize: "20px"}} onClick={() => navigate(urlSupportPage)} />
            </BackButtonTopStyle>
            {
                data.length ? <ChatWindow data={data} loader={loader} /> : <ChatDetailLoader />
            }
            {
                data.length ?
                    <ChatBottomStyle>
                        <ChatSubmissionForm connection={connection} currentId={+(routerParams.chatId)} setData={setData} data={data} setloader={setloader} />
                    </ChatBottomStyle>
                : <ChatSubmitLoader />
            }
        </Stack>
    )
}